import { BaseSyntheticEvent } from 'react';
import styled from 'styled-components';
import { PackagePrices } from 'types/join';

const AdditionalUsersWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.theme.colors.siteCardBorder};
  border-radius: 4px;
  width: fit-content;
  height: 18px;
  overflow: hidden;
`;

const Button = styled.button<{ disabled?: boolean }>`
  background-color: ${props => props.theme.colors.siteGrey};
  border: none;
  border-right: 1px solid ${props => props.theme.colors.siteCardBorder};
  border-left: 1px solid ${props => props.theme.colors.siteCardBorder};
  padding: 0 8px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: 12px;
  color: ${props => (props.disabled ? props.theme.colors.grayDark : props.theme.colors.siteBlack)};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    border-left: none;
    border-radius: 2px 0 0 2px;
  }

  &:last-child {
    border-right: none;
    border-radius: 0 2px 2px 0;
  }
`;

const AdditionalUsersInput = styled.input`
  border: none;
  width: 26px;
  font-size: 13px;
  text-align: center;
  font-family: ${props => props.theme.fonts.interSans};
  outline: none;
  background-color: ${props => props.theme.colors.siteGrey};
  color: ${props => props.theme.colors.siteBlack};

  &:disabled {
    background-color: ${props => props.theme.colors.grayLight};
    color: ${props => props.theme.colors.grayDark};
  }
`;

type AdditionalUsersBoxProps = {
  isActive: boolean;
  numOfAdditionalUser: string;
  setNumber: (e: BaseSyntheticEvent, addonPackage: PackagePrices) => void;
  addon: PackagePrices;
};

export const AdditionalUsersBox = ({
  isActive,
  numOfAdditionalUser,
  setNumber,
  addon
}: AdditionalUsersBoxProps) => {
  const handleDecrement = (e: React.BaseSyntheticEvent, addon: PackagePrices) => {
    const currentValue = parseInt(numOfAdditionalUser) || 0;
    e.target.value = Math.max(currentValue - 1, 0).toString();
    setNumber(e, addon);
  };

  const handleIncrement = (e: React.BaseSyntheticEvent, addon: PackagePrices) => {
    const currentValue = parseInt(numOfAdditionalUser) || 0;
    e.target.value = (currentValue + 1).toString();
    setNumber(e, addon);
  };

  return (
    <AdditionalUsersWrapper>
      <Button disabled={!isActive} onClick={e => handleDecrement(e, addon)}>
        -
      </Button>
      <AdditionalUsersInput
        value={numOfAdditionalUser}
        onChange={e => setNumber(e, addon)}
        disabled={!isActive}
      />
      <Button disabled={!isActive} onClick={e => handleIncrement(e, addon)}>
        +
      </Button>
    </AdditionalUsersWrapper>
  );
};

export default AdditionalUsersBox;
